// extracted by mini-css-extract-plugin
export var description = "portfolio-page-module--description--2dLG0";
export var showMore = "portfolio-page-module--show-more--14FPe";
export var projects = "portfolio-page-module--projects--1Gzm1";
export var projectsList = "portfolio-page-module--projects-list--2NVJO";
export var projectsOverlay = "portfolio-page-module--projects-overlay--3-obM";